import 'uni-pages';import 'uni-h5';uni.app_version = '2.23.3';
import Vue from 'vue';
import App from '@/App';
import store from '@/vuex';
import api from './api';
import globalMixins from '@/mixins/global.js';
import uView from 'uview-ui';
import eventReporter from '@/utils/event-reporter';
import customNav from '@/components/custom-navigation-bar/index';
import returnBall from '@/components/global-return-ball/index';
import showModel from '@/components/global-pop';
import { isProd } from '@/config';
import config from '@/config/index.js';







import { router, RouterMount } from '@/router'; // 路径换成自己的
import Vconsole from 'vconsole';
Vue.use(router);
if (!isProd) {
  new Vconsole();
}


// import '@/js/sr-sdk-wxapp-init';
Vue.component('return-ball', returnBall);
Vue.prototype.$store = store;
Vue.prototype.$api = api;
Vue.component('custom-nav', customNav);
Vue.component('show-model', showModel);
Vue.use(uView);
Vue.mixin(globalMixins);
Vue.config.productionTip = false;
App.mpType = 'app';
// 启动耗时优化，延时初始化
// setTimeout(() => {
//* 设置请求上报接口所需要的header里的参数
eventReporter.setSensorsPara();
//* 对于所有事件都需要添加的属性，可在初始化 SDK 前，调用 registerApp() 将属性注册为公共属性
eventReporter.registerApp({
  shopId: config.EXT_TENANT_ID,
  miniAppsId: config.APPID,
  clientType: config.CLIENT_TYPE,
});

const openId = store.state.openId;
if (openId) {
  eventReporter.setOpenId(openId);
}

eventReporter.init();

const { memberCO } = store.state;
if (memberCO.id) {
  eventReporter.login(memberCO.id, memberCO.mobile);
}
// }, 4000);

const app = new Vue({
  store,
  ...App,
});

// v1.3.5起 H5端 你应该去除原有的app.$mount();使用路由自带的渲染方式

RouterMount(app, router, '#app');




